export const renderClassName = (
  defaultClassName: string,
  className?: string
) => {
  return className
    ? `${defaultClassName} ${className}`.trim()
    : defaultClassName;
};
